import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./layout.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import revaLogo from "../assets/reva-logo.jpg";

import AttributePage from "../pages/attribute.jsx";
import ProductCategoryPage from "../pages/productcategory.jsx";
import TaxPage from "../pages/TaxConfigPage.jsx";
import CategoryAttributeMap from "../pages/CategoryAttributeMap.jsx";
import Vendor from "../pages/Vendor.jsx";
import Products from "../pages/Products.jsx";
import ProductAttributePage from "../pages/Productattribute.jsx";
import InventorySummry from "../pages/Inventorysummry.jsx";
import InventoryTransaction from "../pages/Inventorytransaction.jsx";
import Catalogue from "../pages/Catalogue.jsx";


import ProductPrice from "../pages/ProductPrice.jsx";
import StockReceipt from "../pages/StockReceipt.jsx";
import InvoicePage from "../pages/Invoice.jsx";
import Dashboard from "../pages/Dashboard.jsx";

import NotesPage from "../pages/Notes";


/* ════════════════════════════════════════
   NAV CONFIG  — add new pages here
════════════════════════════════════════ */
const NAV = [
  {
    label: "Main",
    items: [
      { icon: "bi-grid", label: "Dashboard" },
      { icon: "bi-box-seam", label: "Products" },
      {
        icon: "bi-stack",
        label: "Inventory & Stocks",
        children: [
          { label: "Current Stock", page: "Stocks" },
          { label: "Deliveries", page: "Stock Receipt" },
          { label: "Movement History", page: "Inventory Transaction" },
        ],
      },
      { icon: "bi-receipt", label: "Invoice" },
      { icon: "bi-journal-text", label: "Customer Notes" },
    ],
  },
  {
    label: "Masters",
    items: [
      { icon: "bi-sliders", label: "Attributes" },
      { icon: "bi-diagram-3", label: "Category Attribute Map" },
      { icon: "bi-layers", label: "Product Category" },
      { icon: "bi-truck", label: "Vendor" },
      { icon: "bi-receipt-cutoff", label: "Tax Configuration" },
      {
        icon: "bi-gem",
        label: "Catalogue",
        children: [
          { label: "Catalogue Items", tab: "items" },
          { label: "Manage Sections", tab: "sections" },
        ],
      },
    ],
  },
];

/* ════════════════════════════════════════
   PAGE ROUTER  — add new pages here
════════════════════════════════════════ */
function PageContent({ active, onNavigate, catalogueTab, onCatalogueTabChange }) {
  switch (active) {
    case "Dashboard": return <Dashboard onNavigate={onNavigate} />;
    case "Attributes": return <AttributePage />;
    case "Product Category": return <ProductCategoryPage />;
    case "Tax Configuration": return <TaxPage />;
    case "Category Attribute Map": return <CategoryAttributeMap />;
    case "Vendor": return <Vendor />;
    case "Products": return <Products />;
    case "Product Attributes": return <ProductAttributePage />;
    case "Bulk Stock In": return <InventorySummry />;
    case "Inventory Transaction": return <InventoryTransaction onNavigate={onNavigate} />;
    case "Stocks": return <InventorySummry onNavigate={onNavigate} />;




    case "Collections": return <ComingSoon page="Collections" />;
    // case "Products": return <ComingSoon page="Products" />;
    case "Analytics": return <ComingSoon page="Analytics" />;
    case "Catalogue":
    case "Catalouge":
    case "Catalogue Items":
    case "Manage Sections":
    case "Homepage Builder":
      return (
        <Catalogue
          initialTab={catalogueTab || "items"}
          onTabChange={onCatalogueTabChange}
        />
      );


    case "Settings": return <ComingSoon page="Settings" />;
    case "Notifications": return <ComingSoon page="Notifications" />;



    case "Product Price": return <ProductPrice />;
    case "Inventory & Stocks": return <InventorySummry onNavigate={onNavigate} />;
    case "Deliveries":
    case "Stock Inward":
    case "Stock Receipt": return <StockReceipt onNavigate={onNavigate} />;
    case "Invoice": return <InvoicePage />;
    case "Customer Notes": return <NotesPage />;

    default: return <Dashboard onNavigate={onNavigate} />;
  }
}

/* ════════════════════════════════════════
   LAYOUT
════════════════════════════════════════ */
export default function Layout({ initialPage }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [activeItem, setActiveItem] = useState(() => {
    if (initialPage) return initialPage;
    const saved = localStorage.getItem("activePage");
    if (saved === "Catalouge" || saved === "Catalogue") return "Catalogue Items";
    return saved || "Dashboard";
  });
  const [catalogueTab, setCatalogueTab] = useState(() => {
    const active = localStorage.getItem("activePage") || "";
    if (active === "Manage Sections" || active === "Homepage Builder") return "sections";
    return "items";
  });
  const [catalogueExpanded, setCatalogueExpanded] = useState(() => {
    const active = localStorage.getItem("activePage") || "";
    return ["Catalogue", "Catalouge", "Catalogue Items", "Manage Sections", "Homepage Builder"].includes(active);
  });
  const [inventoryExpanded, setInventoryExpanded] = useState(() => {
    const active = localStorage.getItem("activePage") || "";
    return ["Inventory & Stocks", "Stock Receipt", "Stocks", "Stock Inward", "Deliveries", "Live Stock & Barcodes", "Current Stock", "Movement History", "Inventory Transaction"].includes(active);
  });
  const navigate = useNavigate();

  const storedUser = JSON.parse(localStorage.getItem("user"));

  console.log("USER DATA:", storedUser);

  const userName =
    storedUser?.firstName && storedUser?.lastName
      ? `${storedUser.firstName} ${storedUser.lastName}`
      : storedUser?.firstName ||
      storedUser?.lastName ||
      storedUser?.name ||
      storedUser?.fullName ||
      storedUser?.userName ||
      storedUser?.username ||
      storedUser?.email ||
      "User";

  const firstLetter = userName.charAt(0).toUpperCase();

  const handleNav = (label) => {
    let resolvedLabel = (label === "Catalogue" || label === "Catalouge") ? "Catalogue Items" : label;
    if (resolvedLabel === "Homepage Builder") resolvedLabel = "Manage Sections";
    if (resolvedLabel === "Inventory & Stocks") resolvedLabel = "Stocks";
    setActiveItem(resolvedLabel);
    setSidebarOpen(false);
    localStorage.setItem("activePage", resolvedLabel);

    if (["Catalogue", "Catalouge", "Catalogue Items", "Manage Sections"].includes(resolvedLabel)) {
      setCatalogueExpanded(true);
      if (resolvedLabel === "Catalogue Items") setCatalogueTab("items");
      else if (resolvedLabel === "Manage Sections") setCatalogueTab("sections");
    }

    if (["Inventory & Stocks", "Stock Receipt", "Stocks", "Stock Inward", "Deliveries", "Live Stock & Barcodes", "Current Stock", "Movement History", "Inventory Transaction"].includes(resolvedLabel)) {
      setInventoryExpanded(true);
    }
  };

  const handleSubItemClick = (sub) => {
    if (sub.tab) {
      setCatalogueTab(sub.tab);
      handleNav(sub.label);
    } else if (sub.page) {
      handleNav(sub.page);
    } else {
      handleNav(sub.label);
    }
  };

  const handleCatalogueTabChange = (newTab) => {
    const resolvedTab = newTab === "builder" ? "sections" : newTab;
    setCatalogueTab(resolvedTab);
    const tabLabelMap = {
      items: "Catalogue Items",
      sections: "Manage Sections",
    };
    const newLabel = tabLabelMap[resolvedTab] || "Catalogue";
    setActiveItem(newLabel);
    localStorage.setItem("activePage", newLabel);
  };

  useEffect(() => {
    const handleRevaNav = (e) => {
      if (e?.detail) handleNav(e.detail);
    };
    window.addEventListener("reva:navigate", handleRevaNav);
    return () => window.removeEventListener("reva:navigate", handleRevaNav);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("user");
    localStorage.removeItem("activePage");
    navigate("/");
  };

  return (
    <div className="rv-layout">

      {/* ══ SIDEBAR ══ */}
      <aside className={`rv-sidebar ${sidebarOpen ? "rv-sidebar--open" : ""}`}>

        {/* Logo */}
        <div className="rv-logo" onClick={() => handleNav("Dashboard")} style={{ cursor: "pointer" }}>
          <img src={revaLogo} alt="Reva Jewellers Logo" className="rv-logo-img" />
          <span className="rv-logo-text">REVA</span>
        </div>

        {/* Nav */}
        <nav className="rv-nav">
          {NAV.map(group => (
            <div className="rv-nav-group" key={group.label}>
              <p className="rv-nav-label">{group.label}</p>
              {group.items.map(item => {
                if (item.children && item.children.length > 0) {
                  const isInv = item.label === "Inventory & Stocks";
                  const isParentActive = isInv
                    ? ["Inventory & Stocks", "Stock Receipt", "Stocks", "Stock Inward", "Deliveries", "Live Stock & Barcodes", "Current Stock", "Movement History", "Inventory Transaction"].includes(activeItem)
                    : ["Catalogue", "Catalouge", "Catalogue Items", "Manage Sections", "Homepage Builder"].includes(activeItem);
                  const isExpanded = isInv ? inventoryExpanded : catalogueExpanded;
                  const toggleExpanded = isInv ? () => setInventoryExpanded(v => !v) : () => setCatalogueExpanded(v => !v);

                  return (
                    <div className="rv-nav-parent-group" key={item.label}>
                      <button
                        type="button"
                        className={`rv-nav-item rv-nav-parent-btn ${isParentActive ? "rv-nav-item--parent-active" : ""}`}
                        onClick={toggleExpanded}
                      >
                        <span className="rv-nav-icon">
                          <i className={`bi ${item.icon}`} />
                        </span>
                        <span className="rv-nav-text">{item.label}</span>
                        <span className={`rv-nav-arrow ${isExpanded ? "rv-nav-arrow--open" : ""}`}>
                          <i className="bi bi-chevron-down" />
                        </span>
                      </button>

                      {isExpanded && (
                        <div className="rv-nav-tree">
                          {item.children.map(sub => {
                            const isSubActive =
                              activeItem === sub.label ||
                              (sub.page && activeItem === sub.page) ||
                              (sub.tab && (activeItem === "Catalogue" || activeItem === "Catalouge") && catalogueTab === sub.tab);
                            return (
                              <button
                                key={sub.label}
                                type="button"
                                className={`rv-nav-subitem ${isSubActive ? "rv-nav-subitem--active" : ""}`}
                                onClick={() => handleSubItemClick(sub)}
                              >
                                <span className="rv-nav-subitem-dot" />
                                <span className="rv-nav-subitem-text">{sub.label}</span>
                                {isSubActive && <span className="rv-nav-subitem-pip" />}
                              </button>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  );
                }

                return (
                  <button
                    key={item.label}
                    className={`rv-nav-item ${activeItem === item.label ? "rv-nav-item--active" : ""}`}
                    onClick={() => handleNav(item.label)}
                  >
                    <span className="rv-nav-icon">
                      <i className={`bi ${item.icon}`} />
                    </span>
                    <span className="rv-nav-text">{item.label}</span>
                    {activeItem === item.label && <span className="rv-nav-pip" />}
                  </button>
                );
              })}
            </div>
          ))}
        </nav>

        {/* User card */}
        <div className="rv-user">
          <div className="rv-avatar">{firstLetter}</div>

          <div className="rv-user-info">
            <p className="rv-user-name">{userName}</p>
            <p className="rv-user-role">Store Admin</p>
          </div>
          <button className="rv-logout" title="Logout" onClick={handleLogout}>
            <i className="bi bi-box-arrow-right" />
          </button>
        </div>
      </aside>

      {/* Mobile overlay */}
      {sidebarOpen && (
        <div className="rv-overlay" onClick={() => setSidebarOpen(false)} />
      )}

      {/* ══ MAIN ══ */}
      <div className="rv-main">

        {/* HEADER */}
        <header className="rv-header">
          <div className="rv-header-left">
            <button
              className="rv-hamburger d-lg-none"
              onClick={() => setSidebarOpen(v => !v)}
            >
              <span /><span /><span />
            </button>
            <div>
              <h1 className="rv-page-title">
                {{
                  "Stock Receipt": "Deliveries",
                  "Deliveries": "Deliveries",
                  "Stocks": "Current Stock",
                  "Current Stock": "Current Stock",
                  "Inventory Transaction": "Movement History",
                }[activeItem] || activeItem}
              </h1>
            </div>
          </div>
        </header>

        {/* PAGE CONTENT */}
        <main className="rv-content">
          <PageContent
            active={activeItem}
            onNavigate={handleNav}
            catalogueTab={catalogueTab}
            onCatalogueTabChange={handleCatalogueTabChange}
          />
        </main>

      </div>
    </div>
  );
}

/* ════════════════════════════════════════
   COMING SOON stub
════════════════════════════════════════ */
function ComingSoon({ page }) {
  return (
    <div style={{
      display: "flex", flexDirection: "column",
      alignItems: "center", justifyContent: "center",
      height: "60vh", gap: "12px", textAlign: "center",
    }}>
      <div style={{
        width: 60, height: 60, borderRadius: "50%",
        background: "rgba(185,167,146,.14)",
        display: "flex", alignItems: "center", justifyContent: "center",
        color: "var(--taupe)", fontSize: 26,
      }}>
        <i className="bi bi-clock" />
      </div>
      <p style={{ fontFamily: "var(--d-font)", fontSize: 14, color: "var(--dark)" }}>
        {page}
      </p>
      <p style={{ fontSize: 12.5, color: "var(--taupe)" }}>
        This page is coming soon.
      </p>
    </div>
  );
}